import React, { useState } from 'react';
import imageUrl from '../assets/bg.png';
import Loader from '../common/Loader';
const AboutScreen = () => {
  const [showLoader, setShowLoader] = useState(true);
  setTimeout(() => {
    setShowLoader(false);
  }, 1000);
  return (
    <div
      className={`bg-${imageUrl} bg-cover bg-center bg-no-repeat bg-slate-800 text-white`}
      style={{ backgroundImage: `url(${imageUrl})` }}
    >
      {showLoader && (
        <div className='inline-block'>
          <Loader />
        </div>
      )}
      {!showLoader && (
        <div className='container text-left py-10 max-w-5xl'>
          <h2 className='text-[20px] font-semibold'>About Star Cineplex</h2>
          <h4 className='text-[20px] font-medium'>
            The First Multiplex Cinema Theatre in Bangladesh
          </h4>
          <div>
            <p>
              STAR CINEPLEX : Show Motion Limited, incorporated in 19th December
              2002, pioneered the modern Multiplex Movie Theater industry with
              STAR Cineplex brand in Bangladesh.
            </p>{' '}
            <br />
            <p>
              The First Multiplex Cinema Theatre in Bangladesh STAR CINEPLEX :
              Show Motion Limited, incorporated in 19th December 2002, pioneered
              the modern Multiplex Movie Theater industry with STAR Cineplex
              brand in Bangladesh. With lucid vision for the entertainment
              development in the country, the local and foreign promoters of
              Show Motion Ltd. started the first international quality
              state-of-the-art multiplex cinema theatre on 8th October 2004 in
              Bangladesh at Bashundhara City Mall at Panthapath, Dhaka.
            </p>{' '}
            <br />
            <p>
              In January 2019, STAR Cineplex opened another branch in Shimanto
              Shambhar. The new branch has 3 fully digital cinema screens with
              state-of-the-art 3D Projection Technology, Silver Screens,
              Dolby-Digital Sound and stadium seating. One of the 3 halls will
              have ATMOS sound system which will make the movie watching even
              more brilliant. Hall 1 has a seating capacity of 263, Hall 2 has
              that of 253 and 3 has the capacity of 221, totaling to more than
              730 seats.
            </p>{' '}
            <br />
            <p>
              STAR Cineplex, Bashundhara City shooping mall branch has six fully
              digital cinema screens with state-of-the-art 3D Projection
              Technology, Silver Screens, Dolby-Digital Sound and stadium
              seating. With a total capacity of 1,600 seats the theater has
              large lobby with full concession stands serving pop-corns, soft
              drinks, ice-creams and many other items. In addition to scheduled
              shows, STAR Cineplex also caters to special corporate bookings,
              red-carpet premieres and private events. Visit www.cineplexbd.com
              for updated movie schedules and online ticket purchase
            </p>
          </div>
          <h2>Our Goal</h2>
          <p>
            Our goal is to provide the most modern, comfortable, cinema viewing
            experience of Hollywood and quality Dhallywood releases for a
            locally adjusted price for our youth and family centered audiences
            in Dhaka . We aim to be the highest-value entertainment provider in
            Bangladesh with integrity & professionalism in every step.
          </p>
        </div>
      )}
    </div>
  );
};

export default AboutScreen;
